module.exports = __webpack_public_path__ + "img/1440.7a59c503.jpg";